export { AuthenticatedApp } from './AuthenticatedApp';